import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ShipToHome = createSvgIcon(
  <path d="M12 .087 22.951 8.41 21.75 9.99v1.26H24V24H2.25V9.99L1.049 8.41 12 .087Zm1.5 21.663h8.25V13.5h-3v3.75H16.5V13.5h-3v8.25Zm-2.25 0v-10.5h8.25V8.625h.016L12 2.913 4.484 8.625H4.5V21.75h6.75Z" />,
  'ShipToHome'
);

export { ShipToHome };